var _path;
import * as React from "react";
function SvgChevronFillRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.659 33.309V6.69c0-2.393 2.896-3.59 4.585-1.9l13.309 13.308a2.673 2.673 0 010 3.791L15.244 35.21c-1.688 1.688-4.585.492-4.585-1.901z"
  })));
}
export default SvgChevronFillRight;